import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as Yup from 'yup';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import { APP_LABELS } from '@config/app-config';
import CustomModal from '@utilities/CustomModal';
import { DOWNLOAD_CAMP_PDF } from '@config/api-config';
import TextError from '@modules/shared/components/reusable-components/text-error';
import ErrorPopup from '@modules/employee-data-collection/components/upload-file/error-popup';
import LastUpdateName from '@modules/annual-reports/components/anuual-reports-overview/last-update-name';

import { getOvernightCampDataReviewSubmit } from '@redux/overnight-camp-data-review-and-submit/action';

import { AssociationAdminLoginDetailsSelector } from '@redux/login/selectors';
import { ApiParaSelector } from '@redux/overnight-camp-data-apiParameter/selectors';
import { getOvernightCampReviewAndSubmitSelector } from '@redux/overnight-camp-data-review-and-submit/selectors';
import { OvernightCampBranchDetailsDashboardSelector } from '@redux/overnight-camp-data-report-dashboard/selectors';

import pdfIcon from '@static/images/pdfIcon.svg';

import Popup from './popup';

const CampReviewAndSubmitTab = props => {
  const {
    setLoader,
    LoginUserData,
    ApiParameterData,
    handleResetRedux,
    handleGetReviewSubmit,
    allCampBranchDashboardData,
    ReviewSubmitInfoSelectorData
  } = props;

  const role = get(LoginUserData, 'user.role[0]');
  const authToken = JSON.parse(sessionStorage.getItem('token'));
  const branchData = JSON.parse(
    sessionStorage.getItem('yusa_selected_camp_branch')
  );

  const [inCompleteList, setInCompleteList] = useState([]);
  const [dataStatus, setDataStatus] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [errorPopup, setErrorPopup] = useState(false);
  const [instructions, setInstructions] = useState('');
  const [formData, setFormData] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const initialValues = {
    ShareCampData: '',
    ShareACASurvey: ''
  };

  const getShareValue = value => {
    if (value === null) return '';
    if (value) return 'yes';
    return 'no';
  };

  const editValues = {
    ShareCampData: getShareValue(
      ReviewSubmitInfoSelectorData?.reviewSubmitData?.shareCampData
    ),
    ShareACASurvey: getShareValue(
      ReviewSubmitInfoSelectorData?.reviewSubmitData?.shareACASurvey
    )
  };

  const validationSchema = Yup.object({
    ShareCampData: Yup.string().required('* Please select an option'),
    ShareACASurvey: Yup.string().required('* Please select an option')
  });

  const handleGetCall = () => {
    setLoader(true);
    handleGetReviewSubmit(
      ApiParameterData?.branchNumber,
      ApiParameterData?.reportBatchId,
      ApiParameterData?.year
    )
      .then(res => {
        setDataStatus(res?.data?.data?.status);
        setInCompleteList(get(res, 'data.data.dashboardMenuList', []));
        setLoader(false);
        window.scroll(0, 0);
      })
      .catch(() => {
        setLoader(false);
        setErrorPopup(true);
      });
  };

  useEffect(() => {
    window.scroll(0, 0);
    handleGetCall();
    setInstructions(
      JSON.parse(sessionStorage.getItem('allinstructions'))?.[
        'review-and-submit-camp'
      ]?.Instruction
    );

    return () => {
      handleResetRedux('getReviewSubmit');
    };
  }, []);

  const handleSubmit = values => {
    setIsModalOpen(true); // Open the modal if the form is valid
    setFormData(values);
  };

  const downloadPdfApi = () => {
    setLoader(true);
    const Offset = new Date().getTimezoneOffset();
    axios
      .get(
        DOWNLOAD_CAMP_PDF(
          ApiParameterData?.branchNumber,
          ApiParameterData?.year,
          Offset
        ),
        {
          responseType: 'blob',
          headers: {
            'Content-Type': 'blob',
            'Access-Control-Allow-Credentials': true,
            'Access-Control-Allow-Origin': window.location.origin,
            'Ocp-Apim-Subscription-Key': APP_LABELS.APIM_KEY,
            Authorization: `Bearer ${get(authToken, 'token', '')}`
          }
        }
      )
      .then(res => {
        const fileName = `${
          allCampBranchDashboardData?.data
            ? allCampBranchDashboardData?.data[0]?.branchName
            : branchData?.CampName
        } - Overnight-Camp.pdf`;
        const downloadUrl = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', fileName.replaceAll('"', ''));
        document.body.appendChild(link);
        link.click();
        link.remove();
        setLoader(false);
      })
      .catch(() => {
        setLoader(false);
        setErrorPopup(true);
      });
  };

  const scrollToErrors = errors => {
    const errorKeys = Object.keys(errors);

    if (errorKeys?.length > 0) {
      setIsModalOpen(false);
    }
  };

  return (
    <>
      <Formik
        initialValues={editValues || initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ dirty, errors }) => {
          sessionStorage.setItem('dirty', dirty);
          return (
            <Form autoComplete="off">
              <>
                <div className="ymca-completeBox ymca-overDraftView ymca-covidRelif">
                  <div className="ymca-program p-1">
                    <div className="row">
                      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="YMCA-outline">
                          <h4 className="ymca-programActivities mt-0 pb-2">
                            Review & Submit
                          </h4>

                          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-3">
                            <div className="ymca-instructionBoxes">
                              <h4 className="ymca-instructHeadline">
                                {APP_LABELS.INSTRUCTIONS}
                              </h4>
                              <p className="ymca-instructTitle">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: instructions
                                  }}
                                />
                              </p>
                            </div>
                            <p className="ymca-consent">
                              <b>
                                Y-USA agrees to use the data provided by Local
                                Ys in compliance with applicable data protection
                                laws. In order to view other Y's data for
                                comparison purpose, your Y agrees in turn to
                                share your data.
                              </b>
                            </p>
                          </div>

                          <div className="ymca-tableResponsive">
                            <table className="table ymca-table table-striped ymca-autoLength">
                              <thead>
                                <tr className="ymca-cuttingData">
                                  <th>&nbsp;</th>
                                  <th className="text-center">Yes</th>
                                  <th className="text-center">No</th>
                                </tr>
                              </thead>
                              <tbody className="ymca-cuttingBody ymca-lengths">
                                <tr>
                                  <td className="txt-mandatory">
                                    {APP_LABELS.REVIEW_SUBMIT_CHECKBOX1_TEXT}
                                  </td>
                                  <td className="ymca-fieldLine text-center">
                                    <Field
                                      className="styled-radio"
                                      type="radio"
                                      name="ShareCampData"
                                      value="yes"
                                      id="ShareCampData_yes"
                                    />
                                    <ErrorMessage
                                      component={TextError}
                                      name="ShareCampData"
                                    />
                                  </td>
                                  <td className="ymca-fieldLine text-center">
                                    <Field
                                      className="styled-radio"
                                      type="radio"
                                      name="ShareCampData"
                                      value="no"
                                      id="ShareCampData_no"
                                    />
                                  </td>
                                </tr>
                                {/* Second Radio Button Group */}
                                <tr>
                                  <td className="txt-mandatory">
                                    {APP_LABELS.REVIEW_SUBMIT_CHECKBOX2_TEXT}
                                  </td>
                                  <td className="ymca-fieldLine text-center">
                                    <Field
                                      className="styled-radio"
                                      type="radio"
                                      name="ShareACASurvey"
                                      value="yes"
                                      id="ShareACASurvey_yes"
                                    />
                                    <ErrorMessage
                                      component={TextError}
                                      name="ShareACASurvey"
                                    />
                                  </td>
                                  <td className="ymca-fieldLine text-center">
                                    <Field
                                      className="styled-radio"
                                      type="radio"
                                      name="ShareACASurvey"
                                      value="no"
                                      id="ShareACASurvey_no"
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            {dataStatus.toUpperCase() !== 'YETTOBEGIN' && (
                              <button
                                className="btn ymca-pdfFormat d-flex custom-align"
                                type="button"
                                onClick={downloadPdfApi}
                              >
                                <img
                                  src={pdfIcon}
                                  alt="download-template-icon"
                                  className="img-fluid me-2 template-icon"
                                />
                                Download PDF
                              </button>
                            )}

                            {role !== APP_LABELS.YUSA_DATA_VIEWER && (
                              <button
                                className="btn ymca-submitBlue d-flex custom-align"
                                type="submit"
                                onClick={() => scrollToErrors(errors)}
                                disabled={
                                  dataStatus?.toUpperCase() ===
                                  APP_LABELS.STATUS_SUBMITTED
                                }
                              >
                                Submit
                              </button>
                            )}

                            {dataStatus?.toUpperCase() ===
                              APP_LABELS.STATUS_SUBMITTED && (
                              <div className="alert alert-danger" role="alert">
                                {APP_LABELS.REVIEW_SUBMIT_CAMP_SUBMITTED_TEXT}
                              </div>
                            )}

                            <div className="ymca-submitHighlighter">
                              <LastUpdateName
                                Username={
                                  ReviewSubmitInfoSelectorData?.reviewSubmitData
                                    ?.updatedByName
                                }
                                Time={
                                  ReviewSubmitInfoSelectorData?.reviewSubmitData
                                    ?.updatedDatetime
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            </Form>
          );
        }}
      </Formik>

      <Popup
        modalOpen={isModalOpen}
        handleClosePopup={() => {
          setIsModalOpen(false);
        }}
        inCompleteList={inCompleteList}
        setSubmitStatus={setSubmitStatus}
        setShowPopup={setShowPopup}
        setLoader={setLoader}
        fromValues={formData}
        remaingTabs={
          ReviewSubmitInfoSelectorData?.data?.dashboardMenuList.length
        }
        ReviewSubmitInfoSelectorData={ReviewSubmitInfoSelectorData}
      />

      <CustomModal
        show={showPopup}
        type={submitStatus ? APP_LABELS.SUCCESS : APP_LABELS.ERROR}
        message={
          submitStatus
            ? APP_LABELS.REVIEW_REDIRECTING_TO_DASHBOARD_CAMP
            : APP_LABELS.COMMON_ERROR_MESSAGE
        }
        submitButtonName={submitStatus ? 'Ok' : 'Cancel'}
        onSubmit={() => {
          setShowPopup(false);
          setRedirect(true);
        }}
      />

      {redirect && <Redirect to="/overnight-camp-data/dashboard" />}

      <ErrorPopup
        handleCloseErrorPopup={() => {
          setErrorPopup(false);
        }}
        errorMessage={APP_LABELS.COMMON_ERROR_MESSAGE}
        showErrorPopup={errorPopup}
      />
    </>
  );
};

CampReviewAndSubmitTab.propTypes = {
  setLoader: PropTypes.func.isRequired,
  handleResetRedux: PropTypes.func.isRequired,
  handleGetReviewSubmit: PropTypes.func.isRequired,
  ApiParameterData: PropTypes.objectOf(PropTypes.any).isRequired,
  LoginUserData: PropTypes.objectOf(PropTypes.any).isRequired,
  allCampBranchDashboardData: PropTypes.objectOf(PropTypes.any).isRequired,
  ReviewSubmitInfoSelectorData: PropTypes.objectOf(PropTypes.any).isRequired
};

const mapStateToProps = state => ({
  ApiParameterData: ApiParaSelector(state),
  allCampBranchDashboardData:
    OvernightCampBranchDetailsDashboardSelector(state),
  LoginUserData: AssociationAdminLoginDetailsSelector(state),
  ReviewSubmitInfoSelectorData: getOvernightCampReviewAndSubmitSelector(state)
});

const mapDispatchToProps = {
  handleGetReviewSubmit: getOvernightCampDataReviewSubmit
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(CampReviewAndSubmitTab));
